/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { StreamableFile } from '../models';
/**
 * EngageAiSessionApi - axios parameter creator
 * @export
 */
export const EngageAiSessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        engageAISessionControllerGetFile: async (fileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling engageAISessionControllerGetFile.');
            }
            const localVarPath = `/api/engage-ai-session/file/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} runId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        engageAISessionControllerGetRunStatus: async (runId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            if (runId === null || runId === undefined) {
                throw new RequiredError('runId','Required parameter runId was null or undefined when calling engageAISessionControllerGetRunStatus.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling engageAISessionControllerGetRunStatus.');
            }
            const localVarPath = `/api/engage-ai-session/{id}/run-status/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EngageAiSessionApi - functional programming interface
 * @export
 */
export const EngageAiSessionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engageAISessionControllerGetFile(fileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<StreamableFile>>> {
            const localVarAxiosArgs = await EngageAiSessionApiAxiosParamCreator(configuration).engageAISessionControllerGetFile(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} runId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engageAISessionControllerGetRunStatus(runId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await EngageAiSessionApiAxiosParamCreator(configuration).engageAISessionControllerGetRunStatus(runId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EngageAiSessionApi - factory interface
 * @export
 */
export const EngageAiSessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engageAISessionControllerGetFile(fileId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<StreamableFile>> {
            return EngageAiSessionApiFp(configuration).engageAISessionControllerGetFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the status of a Run given the sessionId and runId
         * @param {string} runId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engageAISessionControllerGetRunStatus(runId: string, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return EngageAiSessionApiFp(configuration).engageAISessionControllerGetRunStatus(runId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EngageAiSessionApi - object-oriented interface
 * @export
 * @class EngageAiSessionApi
 * @extends {BaseAPI}
 */
export class EngageAiSessionApi extends BaseAPI {
    /**
     * 
     * @summary Gets the status of a Run given the sessionId and runId
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngageAiSessionApi
     */
    public async engageAISessionControllerGetFile(fileId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<StreamableFile>> {
        return EngageAiSessionApiFp(this.configuration).engageAISessionControllerGetFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Gets the status of a Run given the sessionId and runId
     * @param {string} runId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngageAiSessionApi
     */
    public async engageAISessionControllerGetRunStatus(runId: string, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return EngageAiSessionApiFp(this.configuration).engageAISessionControllerGetRunStatus(runId, id, options).then((request) => request(this.axios, this.basePath));
    }
}
